import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-trucks-view",
  templateUrl: "./admin-trucks-view.component.html",
  styleUrls: ["./admin-trucks-view.component.css"],
})
export class AdminTrucksViewComponent implements OnInit {
  editTruckProfile: boolean = false;
  truckProfile: boolean = true;
  token: any;
  editTruckFrom!: FormGroup;
  truckImage: any;
  file: any = "";
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truck_documents_proofs: any = [];
  RCImageName: any;
  permitImageName: any;
  fitnessImageName: any;
  pollutionImageName: any;
  insuranceImageName: any;
  profileImg: boolean = true;
  uploadVehicle: boolean = true;
  uploadPermit: boolean = true;
  uploadFitness: boolean = true;
  uploadPollution: boolean = true;
  uploadInsurance: boolean = true;
  RCImage: any;
  permitImage: any;
  fitnessImage: any;
  pollutionImage: any;
  insuranceImage: any;
  updateRC: boolean = true;
  updatePermit: boolean = true;
  updateFitness: boolean = true;
  updatePollution: boolean = true;
  updateInsurance: boolean = true;
  NotesData: any;
  loading: boolean = false;
  selectTruckValue: any;
  truckList: any = [];
  truckCategory: any = [];
  trucksList: any = [];
  remarksArray: any = [];
  truckOwner: any = [];
  filterTruckOwner: any = [];
  reasons: boolean = true;
  reasonsView: boolean = true;
  truckOwnerName: any = [];
  truckImageloading: boolean = false;
  rcLoading: boolean = false;
  permitLoading: boolean = false;
  fitnessLoading: boolean = false;
  pollutionLoading: boolean = false;
  insuranceLoading: boolean = false;
  perPage: any = 100;
  startPage: any = 1;
  searchEmployeeName: any = -1;
  currentOwner: any;
  isTypeLoading: boolean = false;
  constructor(
    private matDialogRef: MatDialogRef<AdminTrucksViewComponent>,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getTrucks();
    this.GetNotes();
    this.GetCategory();
    this.getTruckType();
    this.TruckOwner();

    this.editTruckFrom = this.formBuilder.group({
      truck_number: [
        "",
        Validators.compose([Validators.pattern("^[A-Z0-9\\s]+$")]),
      ],
      rc_valid: [""],
      home_location: [""],
      make_name: [""],
      truck_model: [""],
      manufacture_year: [""],
      vehicle_rc_expiry: [""],
      vehicle_rc: [""],
      permit_type_expiry: [""],
      permit_type: [""],
      fitness_expiry: [""],
      fitness: [""],
      pollution_expiry: [""],
      pollution: [""],
      insurance_expiry: [""],
      insurance: [""],
      truck_category: ["", [Validators.required]],
      truck_type: ["", [Validators.required]],
      truck_status: [""],
      truck_remarks: [""],
      truckowner_id: ["", [Validators.required]],
    });

    if (this.data.truck_remarks == "") {
      this.reasonsView = false;
    }
  }

  public GetNotes() {
    let token = localStorage.getItem("adminToken");
    this.services.GetNotes(this.data._id, token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.NotesData = response.body.data.filter(
            (item: any) => item.module_type === "truck"
          );
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public TruckOwner() {
    this.services
      .getUsersTruckOwnerDetails(this.token)
      .subscribe((response: any) => {
        if (response.status === 200) {
          this.truckOwner = response.body.data;
          this.truckOwner = response.body.data.filter(
            (item: any) => item.username
          );

          this.currentOwner = this.truckOwner.find(
            (ele: any) => ele._id === this.data.truckowner_id
          );
          if (this.currentOwner) {
            this.editTruckFrom.controls["truckowner_id"].setValue(
              this.currentOwner._id
            );
          }
        }
      });
  }

  public gettruckCatg(item: any) {
    this.selectTruckValue = item.value;
    this.isTypeLoading = true;
    this.editTruckFrom.controls["truck_type"].setValue("");
    this.services.GetTypeTruck(this.selectTruckValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckList = response.body.data;
          this.isTypeLoading = false;
        }
      },
      (error) => {
        this.isTypeLoading = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public GetCategory() {
    this.services
      .GetCategory(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.truckCategory = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public getTruckType() {
    this.services.GetTrucksTypeAll(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckList = response.body;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  viewImages() {
    if (this.data.truck_documents_proofs?.vehicle_rc) {
      let RCArray = this.data.truck_documents_proofs.vehicle_rc.split("20");

      // Check if RCArray has at least 3 elements
      if (RCArray.length >= 3) {
        this.RCImageName = RCArray[2];
      } else {
        this.RCImageName = null; // Or handle the error as needed
      }
    } else {
      this.RCImageName = null; // Or handle the error as needed
    }
  }

  permitImg() {
    if (this.data.truck_documents_proofs?.permit_type) {
      let permitArray =
        this.data.truck_documents_proofs.permit_type.split("20");

      // Check if permitArray has at least 3 elements
      if (permitArray.length >= 3) {
        this.permitImageName = permitArray[2];
      } else {
        this.permitImageName = null; // Or handle the error as needed
      }
    } else {
      this.permitImageName = null; // Or handle the error as needed
    }
  }
  fitnessImg() {
    if (this.data.truck_documents_proofs?.fitness) {
      let fitnessArray = this.data.truck_documents_proofs.fitness.split("20");

      // Check if fitnessArray has at least 3 elements
      if (fitnessArray.length >= 3) {
        this.fitnessImageName = fitnessArray[2];
      } else {
        this.fitnessImageName = null; // Or handle the error as needed
      }
    } else {
      this.fitnessImageName = null; // Or handle the error as needed
    }
  }

  pollutionImg() {
    if (this.data.truck_documents_proofs?.pollution) {
      let pollutionArray =
        this.data.truck_documents_proofs.pollution.split("20");

      // Check if pollutionArray has at least 3 elements
      if (pollutionArray.length >= 3) {
        this.pollutionImageName = pollutionArray[2];
      } else {
        this.pollutionImageName = null; // Or handle the error as needed
      }
    } else {
      this.pollutionImageName = null; // Or handle the error as needed
    }
  }

  insuranceImg() {
    if (this.data.truck_documents_proofs?.insurance) {
      let insuranceArray =
        this.data.truck_documents_proofs.insurance.split("20");

      // Check if insuranceArray has at least 3 elements
      if (insuranceArray.length >= 3) {
        this.insuranceImageName = insuranceArray[2];
      } else {
        this.insuranceImageName = null; // Or handle the error as needed
      }
    } else {
      this.insuranceImageName = null; // Or handle the error as needed
    }
  }

  close() {
    this.matDialogRef.close();
  }

  public get truckEditFormControl() {
    return this.editTruckFrom.controls;
  }

  truckEdit() {
    this.truckProfile = false;
    this.editTruckProfile = true;
    this.truckEditFormControl["truck_number"].setValue(this.data.truck_number);
    this.truckImage = this.data.truck_image;
    this.truckEditFormControl["rc_valid"].setValue(this.data.rc_valid);
    this.truckEditFormControl["home_location"].setValue(
      this.data.home_location
    );
    this.truckEditFormControl["make_name"].setValue(this.data.make_name);
    this.truckEditFormControl["truck_model"].setValue(this.data.truck_model);
    this.truckEditFormControl["manufacture_year"].setValue(
      this.data.manufacture_year
    );
    this.truckEditFormControl["vehicle_rc_expiry"].setValue(
      this.data.truck_documents_proofs.vehicle_rc_expiry
    );
    this.truckEditFormControl["permit_type_expiry"].setValue(
      this.data.truck_documents_proofs.permit_type_expiry
    );
    this.truckEditFormControl["pollution_expiry"].setValue(
      this.data.truck_documents_proofs.pollution_expiry
    );
    this.truckEditFormControl["insurance_expiry"].setValue(
      this.data.truck_documents_proofs.insurance_expiry
    );
    this.truckEditFormControl["fitness_expiry"].setValue(
      this.data.truck_documents_proofs.fitness_expiry
    );
    this.truckEditFormControl["truck_category"].setValue(
      this.data.truckCategoryInfo[0]._id
    );
    this.truckEditFormControl["truck_type"].setValue(
      this.data.truckTypeInfo[0]._id
    );
    this.truckEditFormControl["truck_status"].setValue(this.data.truck_status);
    this.truckEditFormControl["truck_remarks"].setValue(
      this.data.truck_remarks
    );
    this.truckEditFormControl["truckowner_id"].setValue(
      this.data.truckowner_id
    );
    if (this.data.truck_remarks == "") {
      this.reasons = false;
    }
    this.viewImages();
    this.permitImg();
    this.fitnessImg();
    this.pollutionImg();
    this.insuranceImg();
  }

  getTrucks() {
    this.services.trucksGet(this.token).subscribe((response: any) => {});
  }

  public onChange(event: any, type: any): void {
    this.file = event.target.files[0];
    if (type == "Truck") {
      this.truckImageloading = true;
    }
    if (type == "RC") {
      this.rcLoading = true;
    }
    if (type == "PermitType") {
      this.permitLoading = true;
    }
    if (type == "Fitness") {
      this.fitnessLoading = true;
    }
    if (type == "Pollution") {
      this.pollutionLoading = true;
    }
    if (type == "Insurance") {
      this.insuranceLoading = true;
    }
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.truckImageloading = false;
        this.rcLoading = false;
        this.permitLoading = false;
        this.fitnessLoading = false;
        this.pollutionLoading = false;
        this.insuranceLoading = false;

        if (type == "Truck") {
          this.truckImage = response.body.image_link;
          this.profileImg = false;
        }
        if (type == "RC") {
          this.uploadVehicle = false;
          this.updateRC = false;
          this.RCImageName = this.file.name;
          this.editTruckFrom.value.vehicle_rc = response.body.image_link;
        }
        if (type == "PermitType") {
          this.uploadPermit = false;
          this.updatePermit = false;
          this.permitImageName = this.file.name;
          this.editTruckFrom.value.permit_type = response.body.image_link;
        }
        if (type == "Fitness") {
          this.uploadFitness = false;
          this.updateFitness = false;
          this.fitnessImageName = this.file.name;
          this.editTruckFrom.value.fitness = response.body.image_link;
        }
        if (type == "Pollution") {
          this.uploadPollution = false;
          this.updatePollution = false;
          this.pollutionImageName = this.file.name;
          this.editTruckFrom.value.pollution = response.body.image_link;
        }
        if (type == "Insurance") {
          this.uploadInsurance = false;
          this.updateInsurance = false;
          this.insuranceImageName = this.file.name;
          this.editTruckFrom.value.insurance = response.body.image_link;
        }
      }
    });
  }
  UpdateTruck(event:any) {
    // if (this.truckAddFrom.valid) {
    if (this.loading) {
      return; // 🚀 Prevent clicks if already loading
    }
    if (this.editTruckFrom.value.manufacture_year > new Date().getFullYear()) {
      this.snackBar.open(
        "Manufacture year should be less than current year",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (
      this.editTruckFrom.value.truck_number == null ||
      this.editTruckFrom.value.truck_number == ""
    ) {
      this.snackBar.open("Please enter truck number", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.truckImage == null || this.truckImage == "") {
      this.snackBar.open("Please upload truck image", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (
      this.editTruckFrom.value.truck_category == "" ||
      this.editTruckFrom.value.truck_category == null
    ) {
      this.snackBar.open("Please select truck category", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (
      this.isTypeLoading ||
      this.editTruckFrom.value.truck_type == "" ||
      this.editTruckFrom.value.truck_type == null
    ) {
      this.snackBar.open(
        "Please select truck type based on your selected category",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (
      this.editTruckFrom.value.truckowner_id == "" ||
      this.editTruckFrom.value.truckowner_id == null
    ) {
      this.snackBar.open("Please select truck owner", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly

    this.editTruckFrom.value["vehicle_rc"] = this.editTruckFrom.value.vehicle_rc
      ? this.editTruckFrom.value.vehicle_rc
      : this.data.truck_documents_proofs.vehicle_rc;
    this.editTruckFrom.value["permit_type"] = this.editTruckFrom.value
      .permit_type
      ? this.editTruckFrom.value.permit_type
      : this.data.truck_documents_proofs.permit_type;
    this.editTruckFrom.value["fitness"] = this.editTruckFrom.value.fitness
      ? this.editTruckFrom.value.fitness
      : this.data.truck_documents_proofs.fitness;
    this.editTruckFrom.value["pollution"] = this.editTruckFrom.value.pollution
      ? this.editTruckFrom.value.pollution
      : this.data.truck_documents_proofs.pollution;
    this.editTruckFrom.value["insurance"] = this.editTruckFrom.value.insurance
      ? this.editTruckFrom.value.insurance
      : this.data.truck_documents_proofs.insurance;
    this.remarksArray.push(this.editTruckFrom.value.truck_remarks);
    // if (this.editTruckFrom.valid) {
    const isRcVerified =
      this.data.rc_verified === true ||
      this.data.rc_verified === 1 ||
      this.data.is_rc_verified === true ||
      this.data.is_rc_verified === 1 ||
      this.data.truck_documents_proofs?.rc_verified === true ||
      this.data.truck_documents_proofs?.rc_verified === 1;

    this.truck_documents_proofs = {
      vehicle_rc: this.editTruckFrom.value.vehicle_rc,
      vehicle_rc_expiry: this.editTruckFrom.value.vehicle_rc_expiry,
      permit_type: this.editTruckFrom.value.permit_type,
      permit_type_expiry: this.editTruckFrom.value.permit_type_expiry,
      fitness: this.editTruckFrom.value.fitness,
      fitness_expiry: this.editTruckFrom.value.fitness_expiry,
      pollution: this.editTruckFrom.value.pollution,
      pollution_expiry: this.editTruckFrom.value.pollution_expiry,
      insurance: this.editTruckFrom.value.insurance,
      insurance_expiry: this.editTruckFrom.value.insurance_expiry,
      rc_verified: isRcVerified,
      is_rc_verified: isRcVerified,
    };
    const updateTruckObj = {
      truck_number: this.editTruckFrom.value.truck_number,
      rc_valid: this.editTruckFrom.value.rc_valid,
      home_location: this.editTruckFrom.value.home_location,
      make_name: this.editTruckFrom.value.make_name,
      truck_model: this.editTruckFrom.value.truck_model,
      manufacture_year: this.editTruckFrom.value.manufacture_year,
      truck_image: this.truckImage,
      truck_category: this.editTruckFrom.value.truck_category,
      truck_type: this.editTruckFrom.value.truck_type,
      truck_status: this.editTruckFrom.value.truck_status,
      truck_remarks: this.remarksArray,
      truck_documents_proofs: this.truck_documents_proofs,
      truckowner_id: this.editTruckFrom.value.truckowner_id,
      rc_verified: isRcVerified,
      is_rc_verified: isRcVerified,
    };

    this.services
      .truckUpdate(updateTruckObj, this.token, this.data._id)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.snackBar.open("Truck updated successfully", "Success", {
              duration: 5000,
            });
            this.loading = false;
            this.getTrucks();
            // location.reload();
            this.matDialogRef.close();
          }
          setTimeout(() => {
            this.loading = false;
            (event.target as HTMLButtonElement).disabled = false;
          }, 500);
        },
        (error) => {
          setTimeout(() => {
            this.loading = false;
            (event.target as HTMLButtonElement).disabled = false;
          }, 500);
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    // } else {
    //   this.editTruckFrom.markAllAsTouched();
    // }
  }

  maintance() {
    this.editTruckFrom.value.truck_remarks = "";
    this.reasons = false;
  }
  available() {
    this.editTruckFrom.value.truck_remarks = "";
    this.reasons = false;
  }
  rejected() {
    this.reasons = true;
  }

  removeImg(event: any, type: any) {
    if (type == "Truck") {
      this.profileImg = true;
      this.truckImage = "";
    }
    if (type == "RC") {
      this.uploadVehicle = true;
      this.editTruckFrom.value.vehicle_rc = "";
    }
    if (type == "permit") {
      this.uploadPermit = true;
      this.editTruckFrom.value.permit_type = "";
    }
    if (type == "fitness") {
      this.uploadFitness = true;
      this.editTruckFrom.value.firness = "";
    }
    if (type == "pollution") {
      this.uploadPollution = true;
      this.editTruckFrom.value.pollution = "";
    }
    if (type == "insurance") {
      this.uploadInsurance = true;
      this.editTruckFrom.value.insurance = "";
    }
  }
}
